import { render, staticRenderFns } from "./siteHeader.vue?vue&type=template&id=1640fe8c&"
import script from "./siteHeader.vue?vue&type=script&lang=js&"
export * from "./siteHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports